import { render, staticRenderFns } from "./Generator.vue?vue&type=template&id=81023f84&scoped=true"
import script from "./Generator.vue?vue&type=script&lang=js"
export * from "./Generator.vue?vue&type=script&lang=js"
import style0 from "./Generator.vue?vue&type=style&index=0&id=81023f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81023f84",
  null
  
)

export default component.exports